import { IAttachment } from "../mailitem/mail-item-types";
/*
    The following file extensions are on occasion detected as item type attachments when sent from new outlook. Classic will often attach them as regular files. To prevent this inconsistency we detect them and prevent them from being selected.
    .MSG – Outlook Message File

    Represents an individual email message saved from Outlook.
    .OFT – Outlook Template File

    Used for email templates.
    .ICS – iCalendar File

    Represents calendar events.
    .VCF – vCard File

    Used for contacts.
    .PST – Outlook Personal Storage Table

    A full Outlook mailbox archive file.
    .OST – Outlook Offline Storage Table

    Offline mailbox storage (usually not directly attached).
    .DAT – Winmail.dat File

    Used by Outlook's Transport Neutral Encapsulation Format (TNEF) to include rich text formatting and embedded objects.
*/

export const itemAttachmentFileExtensions = [".eml", ".msg", ".oft", ".ics", ".vcf", ".pst", ".ost", ".dat"];

export const isItemAttachment = (x: IAttachment) =>
  x.attachmentType == "item" || !!itemAttachmentFileExtensions.find((ext) => x.name.toLowerCase().endsWith(ext));
